export default "__VITE_ASSET__t4wObh$g__"